import { AuthStore } from '@program-suite/data-auth';
import { MatRadioModule } from '@angular/material/radio';
import {
  ButtonComponent,
  DownloadAIApplicationComponent,
  DownloadAIAppModalData,
  ModalService,
  ModalType,
  SnackbarComponent,
  ToastType,
  UI_FORM_IMPORTS,
} from './../../../../ui-common/src/index';
import { ChangeDetectionStrategy, Component, computed, inject, OnInit, signal, viewChild } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { of } from 'rxjs';
import { pairwise, startWith, tap } from 'rxjs/operators';
import { MatStepper, MatStepperModule } from '@angular/material/stepper';
import { Router } from '@angular/router';
import { MatFormFieldModule } from '@angular/material/form-field';
import { zipCodeStateValidator } from '@program-suite/util-helpers';

import {
  LookupViewModel,
  PolicyChangeStatusEnum,
  PolicyChangeTypeEnum,
  SpinnerStore,
} from '@program-suite/data-common';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { PolicyEndorsementsService } from '@program-suite/data-common';
import { Mode } from '../endorsement.utility';

@Component({
  selector: 'app-additional-insured-form',
  templateUrl: './additional-insured-form.component.html',
  styleUrls: ['./additional-insured-form.component.scss'],
  imports: [
    ...UI_FORM_IMPORTS,
    MatStepperModule,
    ReactiveFormsModule,
    ButtonComponent,
    MatRadioModule,
    MatFormFieldModule,
    MatCheckboxModule
],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdditionalInsuredFormComponent implements OnInit {
  authStore = inject(AuthStore);
  policyChangeService = inject(PolicyEndorsementsService);
  spinner = inject(SpinnerStore);
  modalService = inject(ModalService);

  mode!: Mode;

  //#region Harcoded lookups
  states: LookupViewModel[] = [
    { id: 'AL', name: 'Alabama' },
    { id: 'AK', name: 'Alaska' },
    { id: 'AZ', name: 'Arizona' },
    { id: 'AR', name: 'Arkansas' },
    { id: 'CA', name: 'California' },
    { id: 'CO', name: 'Colorado' },
    { id: 'CT', name: 'Connecticut' },
    { id: 'DE', name: 'Delaware' },
    { id: 'FL', name: 'Florida' },
    { id: 'GA', name: 'Georgia' },
    { id: 'HI', name: 'Hawaii' },
    { id: 'ID', name: 'Idaho' },
    { id: 'IL', name: 'Illinois' },
    { id: 'IN', name: 'Indiana' },
    { id: 'IA', name: 'Iowa' },
    { id: 'KS', name: 'Kansas' },
    { id: 'KY', name: 'Kentucky' },
    { id: 'LA', name: 'Louisiana' },
    { id: 'ME', name: 'Maine' },
    { id: 'MD', name: 'Maryland' },
    { id: 'MA', name: 'Massachusetts' },
    { id: 'MI', name: 'Michigan' },
    { id: 'MN', name: 'Minnesota' },
    { id: 'MS', name: 'Mississippi' },
    { id: 'MO', name: 'Missouri' },
    { id: 'MT', name: 'Montana' },
    { id: 'NE', name: 'Nebraska' },
    { id: 'NV', name: 'Nevada' },
    { id: 'NH', name: 'New Hampshire' },
    { id: 'NJ', name: 'New Jersey' },
    { id: 'NM', name: 'New Mexico' },
    { id: 'NY', name: 'New York' },
    { id: 'NC', name: 'North Carolina' },
    { id: 'ND', name: 'North Dakota' },
    { id: 'OH', name: 'Ohio' },
    { id: 'OK', name: 'Oklahoma' },
    { id: 'OR', name: 'Oregon' },
    { id: 'PA', name: 'Pennsylvania' },
    { id: 'RI', name: 'Rhode Island' },
    { id: 'SC', name: 'South Carolina' },
    { id: 'SD', name: 'South Dakota' },
    { id: 'TN', name: 'Tennessee' },
    { id: 'TX', name: 'Texas' },
    { id: 'UT', name: 'Utah' },
    { id: 'VT', name: 'Vermont' },
    { id: 'VA', name: 'Virginia' },
    { id: 'WA', name: 'Washington' },
    { id: 'WV', name: 'West Virginia' },
    { id: 'WI', name: 'Wisconsin' },
    { id: 'WY', name: 'Wyoming' },
  ];
  relationship: LookupViewModel[] = [
    { id: 'contractor', name: ' Contractor' },
    { id: 'Property Owner/Project Owner', name: 'Property Owner/Project Owner' },
    { id: 'Public Entity/Permits', name: 'Public Entity/Permits' },
    { id: 'Other', name: 'Other' },
  ];
  insurableInterest: LookupViewModel[] = [
    { id: 'General Contractor', name: 'General Contractor' },
    { id: 'Owner', name: 'Owner' },
    { id: 'Developer', name: 'Developer' },
    { id: 'Manager of Premises', name: 'Manager of Premises' },
    { id: 'Other', name: 'Other' },
  ];
  projecttypes: LookupViewModel[] = [
    { id: 'New Construction', name: 'New Construction' },
    { id: 'Repair/Service', name: 'Repair/Service' },
    { id: 'Remodeling', name: 'Remodeling' },
  ];
  dwellingtypes: LookupViewModel[] = [
    { id: 'Custom Home', name: 'Custom Home' },
    { id: 'Tract Home', name: 'Tract Home' },
    { id: 'Condo or Townhome', name: 'Condo or Townhome' },
    { id: 'Apartment', name: 'Apartment' },
    { id: 'Mixed Use Building', name: 'Mixed Use Building' },
  ];
  commercialTypes: LookupViewModel[] = [
    { id: 'Office', name: 'Office' },
    { id: 'Retail', name: 'Retail' },
    { id: 'Restaurant', name: 'Restaurant' },
    { id: 'Warehouse', name: 'Warehouse' },
    { id: 'Manufacturing', name: 'Manufacturing' },
    { id: 'Other', name: 'Other' },
  ];
  workingForTypes: LookupViewModel[] = [
    { id: 'Property Owner or Tenant', name: 'Property Owner or Tenant' },
    { id: 'Builder or Developer', name: 'Builder or Developer' },
    { id: 'Other', name: 'Other' },
  ];
  endorsementtypes: LookupViewModel[] = [
    {
      id: '2',
      name: 'CG 2010 - OWNERS LESSEES OR CONTRACTORS - SCHEDULED PERSON OR ORGANIZATION',
    },
    {
      id: '1',
      name: 'CG 2011 - ADDITIONAL INSURED - MANAGERS OR LESSORS OF PREMISES',
    },
    {
      id: '16',
      name: 'CG 2018 - ADDITIONAL INSURED - MORTGAGEE, ASSIGNEE OR RECEIVER',
    },
    {
      id: '3',
      name: 'CG 2037 - OWNERS LESSEES OR CONTRACTORS - COMPLETED OPERATIONS',
    },
    {
      id: '4',
      name: 'CG 2012 - STATE OR GOVERNMENTAL AGENCY OR SUBDIVISION OR POLITICAL SUBDIVISION - PERMITS OR AUTHORIZATIONS',
    },
    {
      id: '5',
      name: 'GL 1979 - NOTICE OF CANCELLATION - DESIGNATED PERSON(S) OR ORGANIZATION(S)',
    },
    {
      id: '6',
      name: 'CG 2028 - LESSORS OF LEASED EQUIPMENT',
    },
    {
      id: '17',
      name: 'CG 2029 - ADDITIONAL INSURED - GRANTOR OF FRANCHISE',
    },
  ];
  //#endregion

  otherRelationship: boolean = false;

  isLongerForm = signal(false); // TODO change the name of this, we no longer have multiple pages but still needed to determine if the AI type requires an application
  isApplicationComplete = signal(false);
  isLoading = signal(false);
  selectedIndex = signal(0);
  errorList = signal<string[]>([]);
  disableContinue = signal(false);
  showWrittenContractError = signal(false);
  showAiOwnInsuranceError = signal(false);
  data: any;

  roles = computed(() => this.authStore.user()?.roles ?? []);

  stepper = viewChild<MatStepper>('stepper');
  policyChangeGuid: string = '';
  form!: FormGroup;
  backToText = signal<string>('Back to Policy');
  get selectedFormLabel() {
    return this.endorsementtypes.find((x) => x.id === this.form.get('typeOfEndorsement')?.value)?.name;
  }

  goBack() {
    const url = this.router.url;
    const oldUrl = url.split('/additional-insured/')[0];
    this.router.navigate([oldUrl]);
  }

  constructor(private fb: FormBuilder, private snackbar: MatSnackBar, private router: Router) {
    this.createForm();
    this.data = this.router.currentNavigation()?.extras.state || {};
    var url = this.router.url;
    if (url.includes('pending-request')) {
      this.backToText.set('Back to Pending Request');
    }
  }

  ngOnInit(): void {
    if (!this.data?.policyGuid) {
      // HACK if the page refreshes we lose are info so we just go back to the policy
      this.goBack();
      return;
    }

    this.mode = this.determineMode(this.data?.policyChangeStatus);

    let formObject: any = {};
    if (this.mode === 'edit' || this.mode === 'view') {
      formObject = JSON.parse(this.data?.formJSON);
    }

    this.form.get('companyName')?.setValue(this.data?.businessName);
    this.form.get('policyNumber')?.setValue(this.data?.policyNumber);

    this.form.statusChanges.subscribe((val) => {
      if (val === 'VALID') {
        this.errorList.set([]);
      }
    });

    this.form
      .get('typeOfEndorsement')
      ?.valueChanges.pipe(
        startWith(this.form.get('typeOfEndorsement')?.value),
        pairwise(),
        tap(([prev, val]) => {
          if (val === '2' || val === '3') {
            this.isLongerForm.set(true);
            this.setMultipageFormValidators();
            if (this.form.get('additionalPremium')?.value === null) {
              this.form.get('additionalPremium')?.setValue(250);
            }
          } else {
            this.isLongerForm.set(false);
            this.unsetMultipageFormValidators();
            if (prev !== val) {
              this.form.get('additionalPremium')?.setValue(null);
            }
          }
        }),
      )
      .subscribe();

    this.form.get('writtenContract')?.valueChanges.subscribe((val) => {
      if (this.form.get('typeOfEndorsement')?.value === '2' || this.form.get('typeOfEndorsement')?.value === '3') {
        if (val === false) {
          this.disableContinue.set(true);
          this.showWrittenContractError.set(true);
        } else {
          this.disableContinue.set(false);
          this.showWrittenContractError.set(false);
        }
      }
    });

    this.form.get('aiOwnInsurance')?.valueChanges.subscribe((val) => {
      if (this.form.get('typeOfEndorsement')?.value === '2' || this.form.get('typeOfEndorsement')?.value === '3') {
        if (val === false) {
          this.disableContinue.set(true);
          this.showAiOwnInsuranceError.set(true);
        } else {
          this.disableContinue.set(false);
          this.showAiOwnInsuranceError.set(false);
        }
      }
    });

    this.form.get('projectAddressType')?.valueChanges.subscribe((val) => {
      if (this.form.get('typeOfEndorsement')?.value === '3') {
        if (val === 'Residential') {
          this.form.get('singleOrVarious')?.setValue('Single Location');
          this.form.get('singleOrVarious')?.disable();
        } else {
          this.form.get('singleOrVarious')?.enable();
        }

        if (val !== 'Industrial') {
          this.form.get('dwellingType')?.setValidators(Validators.required);
          this.form.updateValueAndValidity();
        } else {
          this.form.get('dwellingType')?.clearValidators();
          this.form.get('dwellingType')?.updateValueAndValidity();
        }
      }
    });

    this.form.get('singleOrVarious')?.valueChanges.subscribe((val) => {
      if (this.form.get('typeOfEndorsement')?.value === '3') {
        if (val === 'Single Location') {
          this.form.get('projectLocation.streetAddress')?.setValidators(Validators.required);
          this.form.get('projectLocation.city')?.setValidators(Validators.required);
          this.form.get('projectLocation.state')?.setValidators(Validators.required);
          this.form.get('projectLocation.zipCode')?.setValidators(Validators.required);
          this.form.updateValueAndValidity();
        } else {
          const fieldsToReset = [
            'projectLocation.streetAddress',
            'projectLocation.city',
            'projectLocation.state',
            'projectLocation.zipCode',
          ];
          for (const field of fieldsToReset) {
            this.form.get(field)?.clearValidators();
            this.form.get(field)?.updateValueAndValidity();
          }
        }
      }
    });

    this.form.get('priorDefect')?.valueChanges.subscribe((val) => {
      if (val) {
        this.form.get('priorDefectExplanation')?.setValidators(Validators.required);
      } else {
        this.form.get('priorDefectExplanation')?.clearValidators();
      }
    });

    this.form.get('typeOfEndorsement')?.setValue('2');
    this.form.get('projectAddressType')?.setValue('Commercial');
    this.form.get('singleOrVarious')?.setValue('Single Location');

    if (this.mode === 'edit') {
      this.form.patchValue(formObject, { onlySelf: true });
      if (this.data?.policyChangeStatus === 'PendingSignature') {
        this.selectedIndex.set(2);
      }
    }
    if (this.mode === 'view') {
      this.form.patchValue(formObject, { onlySelf: true });
      this.form.disable();
      if (this.data?.policyChangeStatus === 'PendingSignature') {
        this.selectedIndex.set(2);
      }
    }
  }

  private createForm(): void {
    this.form = this.fb.group({
      companyName: this.fb.control({ value: null, disabled: true }),
      policyNumber: this.fb.control({ value: null, disabled: true }),
      typeOfEndorsement: this.fb.control(null, Validators.required),
      cG2001: this.fb.control(true),
      cG2404: this.fb.control(true),
      additionalInsuredName: this.fb.control(
        null,
        Validators.compose([Validators.required, Validators.maxLength(150)]),
      ),
      insuredRelationship: this.fb.control(null),
      isWRAPPolicy: this.fb.control(false),
      location: this.fb.group({
        streetAddress: this.fb.control(null, Validators.required),
        aptSuiteBuilding: this.fb.control(null),
        city: this.fb.control(null, Validators.required),
        state: this.fb.control(null, Validators.required),
        zipCode: this.fb.control(null, [zipCodeStateValidator('state'), Validators.required]),
      }),
      writtenContract: this.fb.control(true),
      insurableInterest: this.fb.control(null, Validators.required),
      operations: this.fb.control(null, Validators.required),
      combinableInterest: this.fb.control(true),
      aiOwnInsurance: this.fb.control(true),
      projectAddressType: this.fb.control(null, Validators.required),
      singleOrVarious: this.fb.control(null),
      projectLocation: this.fb.group({
        streetAddress: this.fb.control(null),
        aptSuiteBuilding: this.fb.control(null),
        city: this.fb.control(null),
        state: this.fb.control('CA'),
        zipCode: this.fb.control(null, [zipCodeStateValidator('state')]),
      }),
      projectLocationVarious: this.fb.control(null),
      projectType: this.fb.control(null, Validators.required),
      estimatedGrossReceipts: this.fb.control(null),
      estimatedStartDate: this.fb.control(null),
      estimatedCompletionDate: this.fb.control(null),
      projectDescription: this.fb.control(null, Validators.required),
      projectNotes: this.fb.control(null),
      dwellingType: this.fb.control(null),
      workingFor: this.fb.control(null),
      priorDefect: this.fb.control(false),
      priorDefectExplanation: this.fb.control(null),
      willHireSubcontractors: this.fb.control(true),
      subsWrittenContract: this.fb.control(true),
      subsAdditionalInsured: this.fb.control(true),
      additionalPremium: this.fb.control(null),
      acknowledgement: this.fb.control(false, Validators.required),
    });
  }

  get zipCode() {
    return this.form.get('location.zipCode');
  }

  setMultipageFormValidators() {
    this.form.get('location.streetAddress')?.setValidators(Validators.required);
    this.form.get('location.city')?.setValidators(Validators.required);
    this.form.get('location.state')?.setValidators(Validators.required);
    this.form.get('location.zipCode')?.setValidators([Validators.required, zipCodeStateValidator('location.state')]);
    this.form.get('writtenContract')?.setValidators(Validators.required);
    this.form.get('insurableInterest')?.setValidators(Validators.required);
    this.form.get('operations')?.setValidators(Validators.required);
    this.form.get('combinableInterest')?.setValidators(Validators.required);
    this.form.get('aiOwnInsurance')?.setValidators(Validators.required);
    this.form.get('projectAddressType')?.setValidators(Validators.required);
    this.form.get('singleOrVarious')?.setValidators(Validators.required);
    this.form.get('estimatedGrossReceipts')?.setValidators(Validators.required);
    this.form.get('estimatedStartDate')?.setValidators(Validators.required);
    this.form.get('estimatedCompletionDate')?.setValidators(Validators.required);
    this.form.get('dwellingType')?.setValidators(Validators.required);
    this.form.get('acknowledgement')?.setValidators(Validators.requiredTrue);
    this.form.get('insuredRelationship')?.setValidators(null);
    this.form.get('isWRAPPolicy')?.setValidators(null);
    this.form.updateValueAndValidity();
  }

  unsetMultipageFormValidators() {
    const fieldsToReset = [
      'location.streetAddress',
      'location.city',
      'location.state',
      'location.zipCode',
      'writtenContract',
      'insurableInterest',
      'operations',
      'combinableInterest',
      'aiOwnInsurance',
      'projectAddressType',
      'singleOrVarious',
      'estimatedGrossReceipts',
      'estimatedStartDate',
      'estimatedCompletionDate',
      'dwellingType',
      'acknowledgement',
    ];
    for (const field of fieldsToReset) {
      this.form.get(field)?.clearValidators();
      this.form.get(field)?.updateValueAndValidity();
    }
    this.form.get('insuredRelationship')?.setValidators(Validators.required);
    this.form.get('isWRAPPolicy')?.setValidators(Validators.required);
    this.form.updateValueAndValidity();
  }

  formIsValid(form: FormGroup): boolean {
    let isValid = true;

    Object.keys(form.controls).forEach((key) => {
      const control = form.get(key);
      if (control instanceof FormGroup) {
        if (!this.formIsValid(control)) {
        }
      } else {
        if (control && control.invalid) {
          isValid = false;
        }
      }
    });
    return isValid;
  }

  async upsertForm() {
    const formData = new FormData();
    if (this.data?.policyChangeGuid) {
      formData.append('PolicyChangeGuid', this.data?.policyChangeGuid);
    }
    formData.append('PolicyGuid', this.data?.policyGuid);
    formData.append(
      'PolicyChangeType',
      this.getPolicyChangeTypeFromId(+this.form.get('typeOfEndorsement')?.value) as string,
    );
    formData.append('FormJSON', JSON.stringify(this.form.getRawValue()));

    try {
      const policyChangeGuid = await this.policyChangeService.upsertPolicyChangeRequest(formData);
      this.data.policyChangeGuid = policyChangeGuid;
    } catch (error) {
      this.snackbar.openFromComponent(SnackbarComponent, {
        duration: 5000,
        data: { toastType: ToastType.Error, message: 'Error occurred while saving the endorsement request' },
      });
    }
  }

  async submitRequest() {
    if (!this.form.valid) {
      this.form.markAllAsTouched();
      this.checkForValidationErrors();
      return;
    }

    const validationErrorHandler = (validationErrors: any) => {
      if (validationErrors.length) {
        validationErrors.forEach((error: any) => {
          const control = this.form.get(error.field);
          if (control) {
            this.form.markAllAsTouched();
            control.setErrors({ message: error.message });
          } else {
            this.snackbar.openFromComponent(SnackbarComponent, {
              duration: 5000,
              data: { toastType: ToastType.Error, message: `${error.message}` },
            });
          }
        });
      } else {
        this.snackbar.openFromComponent(SnackbarComponent, {
          duration: 5000,
          data: { toastType: ToastType.Error, message: 'Something went wrong.' },
        });
      }
      return of(null);
    };

    const changeType = this.getPolicyChangeTypeFromId(+this.form.get('typeOfEndorsement')?.value);

    const formData = new FormData();
    if (this.data?.policyChangeGuid) {
      formData.append('PolicyChangeGuid', this.data?.policyChangeGuid);
    }

    formData.append('PolicyGuid', this.data?.policyGuid);
    formData.append('PolicyChangeType', changeType as string);
    formData.append('FormJSON', JSON.stringify(this.form.getRawValue()));

    try {
      this.policyChangeGuid = await this.policyChangeService.submitPolicyChangeRequest(formData);
      this.data.policyChangeGuid = this.policyChangeGuid;

      // if endorsement type is 2 or 3, go to the download application page, otherwise close the modal
      if (
        changeType === PolicyChangeTypeEnum.AIOwnersLesseesContractors ||
        changeType === PolicyChangeTypeEnum.AICompletedOperations
      ) {
        this.isApplicationComplete.set(true);
        this.goBack();
        this.modalService.open(DownloadAIApplicationComponent, {
          modalType: ModalType.Medium,
          data: {
            policyChangeGuid: this.data.policyChangeGuid,
            businessName: this.data.businessName,
            policyNumber: this.data.policyNumber,
            typeOfEndorsement: this.selectedFormLabel,
          } as DownloadAIAppModalData,
        });
      } else {
        this.goBack();
      }

      this.snackbar.openFromComponent(SnackbarComponent, {
        duration: 5000,
        data: { toastType: ToastType.Success, message: 'Submission of an endorsement request was successful.' },
      });
    } catch (error) {
      validationErrorHandler(error);
    }
  }

  async issuePolicyChange() {
    if (!this.form.valid) {
      this.form.markAllAsTouched();
      this.checkForValidationErrors();
      return;
    }
    const validationErrorHandler = (validationErrors: any) => {
      if (validationErrors.length) {
        validationErrors.forEach((error: any) => {
          const control = this.form.get(error.field);
          if (control) {
            this.form.markAllAsTouched();
            control.setErrors({ message: error.message });
          } else {
            this.snackbar.openFromComponent(SnackbarComponent, {
              duration: 5000,
              data: { toastType: ToastType.Error, message: `${error.message}` },
            });
          }
        });
      } else {
        this.snackbar.openFromComponent(SnackbarComponent, {
          duration: 5000,
          data: { toastType: ToastType.Error, message: 'Error occurred. Endorsement was not issued.' },
        });
      }
      return of(null);
    };
    const confirmRef = window.confirm('Are you sure you want to issue this Endorsement?');
    if (!confirmRef) {
      return;
    }
    const formData = new FormData();
    if (this.data?.policyChangeGuid) {
      formData.append('PolicyChangeGuid', this.data?.policyChangeGuid);
    }
    formData.append('PolicyGuid', this.data?.policyGuid);
    formData.append(
      'PolicyChangeType',
      this.getPolicyChangeTypeFromId(+this.form.get('typeOfEndorsement')?.value) as string,
    );
    formData.append('FormJSON', JSON.stringify(this.form.getRawValue()));

    this.form.disable();

    try {
      await this.policyChangeService.issuePolicyChangeRequest(formData);
      this.goBack();
      this.snackbar.openFromComponent(SnackbarComponent, {
        duration: 5000,
        data: { toastType: ToastType.Success, message: 'Endorsement Issued' },
      });
    } catch (error) {
      validationErrorHandler(error);
      this.form.enable();
    }
  }

  async decline() {
    const confirmRef = window.confirm('Are you sure you want to decline this Endorsement?');
    if (!confirmRef) {
      return;
    }

    try {
      await this.policyChangeService.declinePolicyChangeRequest(this.data);
      this.goBack();
      this.snackbar.openFromComponent(SnackbarComponent, {
        duration: 5000,
        data: { toastType: ToastType.Success, message: 'Endorsement Declined' },
      });
    } catch (error) {
      this.snackbar.openFromComponent(SnackbarComponent, {
        duration: 5000,
        data: { toastType: ToastType.Error, message: 'Error occurred while declining the endorsement request' },
      });
    }
  }

  checkForValidationErrors() {
    const errorList = ['Form validation failed.'];
    for (const key in this.form.controls) {
      const control = this.form.controls[key] as FormGroup;
      if (control.controls) {
        for (const childKey in control.controls) {
          if (control.controls[childKey].errors) {
            errorList.push(`Field: ${key}.${childKey}`);
          }
        }
      } else {
        if (this.form.controls[key].errors) {
          errorList.push(`Field: ${key}`);
        }
      }
    }
    this.errorList.set(errorList);
  }

  download() {
    this.policyChangeService.downloadPolicyChange(this.data?.policyChangeGuid).then(() => {});
  }

  downloadApplication() {
    this.policyChangeService.downloadApplication(this.data?.policyChangeGuid).then(() => {});
  }

  getPolicyChangeTypeFromId(id: number): string | null {
    const keys = Object.keys(PolicyChangeTypeEnum);
    if (id >= 1 && id <= keys.length) {
      return keys[id - 1]; // -1 because enum index is 1-based
    }
    return null;
  }

  determineMode(policyChangeStatus: PolicyChangeStatusEnum): Mode {
    // if admin always edit, unless already issued or declined
    // otherwise, if draft edit
    // otherwise view only

    if (policyChangeStatus === null || policyChangeStatus === undefined) {
      return 'add';
    }

    if (
      policyChangeStatus === PolicyChangeStatusEnum.Issued ||
      policyChangeStatus === PolicyChangeStatusEnum.Declined ||
      policyChangeStatus === PolicyChangeStatusEnum.Voided
    ) {
      return 'view';
    }

    if (this.authStore.isAdmin()) {
      return 'edit';
    }

    if (policyChangeStatus === PolicyChangeStatusEnum.Draft) {
      return 'edit';
    } else {
      return 'view';
    }
  }
}
